const parameters = [
  {
    parameter: "PRICE",
    parameterSyntax: "price=",
  },
  {
    parameter: "GENDER",
    parameterSyntax: "gender=",
  },
  {
    parameter: "AVAILABILITY",
    parameterSyntax: "availability=",
  },
  {
    parameter: "CATEGORY",
    parameterSyntax: "category=",
  },
  {
    parameter: "PAGINATION",
    parameterSyntax: "page=",
  },
];

const invalidParameter = (currentParameter: object) => {
  return !currentParameter;
};

const invalidPath = (path: string) => {
  return !path;
};

const noURLParameters = (path: string) => {
  return !path.includes("?");
};

const emptyValue = (value: string) => {
  return !value;
};

const excludesCurrentParameter = (path: string, parameterSyntax: string) => {
  return !path.includes(parameterSyntax);
};

const oneParameter = (paramaters: string) => {
  return !paramaters.includes("&");
};

const getParameterIndex = (
  parameterSplit: Array<string>,
  parameterSyntax: string
) => {
  let desiredIndex: number;
  for (let i = 0; i < parameterSplit.length; i++) {
    if (parameterSplit[i].includes(parameterSyntax)) {
      desiredIndex = i;
      break;
    }
  }
  return desiredIndex;
};

const newURLParameters = (parameters: Array<string>) => {
  let urlParameters = "";
  for (const value of parameters) {
    if (noURLParameters(urlParameters)) {
      urlParameters = urlParameters + "?" + value;
    } else {
      urlParameters = urlParameters + "&" + value;
    }
  }
  return urlParameters;
};

const urlParameterController = (
  parameter: string,
  value: string,
  path: string
) => {
  let newPath: string;
  const currentParameter = parameters.find(
    (currentParameter) => currentParameter.parameter === parameter
  );
  if (invalidPath(path)) {
    console.log("urlParameterController invalid path");
    return "/";
  }
  if (invalidParameter(currentParameter)) {
    console.log("urlParameterController invalid parameter");
    return path;
  }
  if (noURLParameters(path) && emptyValue(value)) {
    return path;
  }
  if (noURLParameters(path)) {
    newPath = path + "?" + currentParameter.parameterSyntax + value;
    return newPath;
  }
  if (
    excludesCurrentParameter(path, currentParameter.parameterSyntax) &&
    emptyValue(value)
  ) {
    return path;
  }
  if (excludesCurrentParameter(path, currentParameter.parameterSyntax)) {
    newPath = path + "&" + currentParameter.parameterSyntax + value;
    return newPath;
  }
  const [urlPath, urlParameters] = path.split("?");
  if (oneParameter(urlParameters) && emptyValue(value)) {
    return urlPath;
  }
  if (oneParameter(urlParameters)) {
    return urlPath + "?" + currentParameter.parameterSyntax + value;
  }
  const parameterSplit = urlParameters.split("&");
  const parameterToUpdateOrRemove: number = getParameterIndex(
    parameterSplit,
    currentParameter.parameterSyntax
  );
  if (emptyValue(value)) {
    parameterSplit.splice(parameterToUpdateOrRemove, 1);
  } else {
    parameterSplit[parameterToUpdateOrRemove] =
      currentParameter.parameterSyntax + value;
  }
  return urlPath + newURLParameters(parameterSplit);
};

export default urlParameterController;
